/*
 * File: GetCourseEnrollmentCriteria.ts
 * Author: Austin Robinson
 * Date Created: 10/9/2023
 * Copyright (c) DrivingDoc 2023
 */
import { createQuery } from 'react-query-kit';

import { PostGreSQLInterval, privateApi } from 'api';

export type GetCourseEnrollmentCriteriaParams = {
  courseId: string;
};

export type GetCourseEnrollmentCriteriaResult = {
  tenant_id: string;
  course_id: string;
  updated_at: string;
  min_age_to_register: PostGreSQLInterval | null;
  max_age_to_register: PostGreSQLInterval | null;
  min_age_at_first_period: PostGreSQLInterval | null;
  max_age_at_first_period: PostGreSQLInterval | null;
  require_permit_to_register: boolean;
  updated_by_user: {
    tenant_id: string;
    id: string;
    title: string | null;
    first_name: string | null;
    middle_name: string | null;
    last_name: string | null;
    nickname: string | null;
    email: string | null;
    date_of_birth: string | null;
    sex: string | null;
    active: boolean;
    created_at: string | null;
    updated_at: string | null;
    created_by: string | null;
    updated_by: string | null;
    des_id: string | null;
  };
};

async function getCourseEnrollmentCriteria(
  params: GetCourseEnrollmentCriteriaParams,
): Promise<GetCourseEnrollmentCriteriaResult> {
  // make api call
  const result = await privateApi.get(
    `${import.meta.env.VITE_API_BASE_URL}/courses/${params.courseId}/enrollmentCriteria`,
    {},
  );

  // return the data object
  return result.data as GetCourseEnrollmentCriteriaResult;
}

const useGetCourseEnrollmentCriteria = createQuery<
  GetCourseEnrollmentCriteriaResult,
  GetCourseEnrollmentCriteriaParams,
  Error
>({
  queryKey: ['course_enrollment_criteria'],
  fetcher: (variables) => getCourseEnrollmentCriteria(variables),
});

export { getCourseEnrollmentCriteria, useGetCourseEnrollmentCriteria };
